import { truncateString } from '../../packages/kiti/utils/helpers/string'
import { useFieldsFromApi } from '../helpers/fields'

const genRawFieldsInterpolationValue = (fieldsOrigin, field) => {
  switch (field.typeName) {
    case 'number':
    case 'date':
    case 'datetime':
      return `{{#find ${fieldsOrigin} field="field_id" operator="eq" value=${field.id}}}{{raw field_value.value}}{{/find}}`
    default:
      return `{{#find ${fieldsOrigin} field="field_id" operator="eq" value=${field.id}}}{{field_value.value}}{{/find}}`
  }
}

export const useRawFieldsInterpolationsFetcher = (skip, fieldsOrigin, origin, options) => {
  const { group, fetchPolicy } = options || {}
  const { data: fieldsData } = useFieldsFromApi(origin, undefined, { skip, fetchPolicy })
  const fields = fieldsData?.fields || []

  return [
    ...fields?.map(field => ({
      name: truncateString(field.name, 30),
      fullName: field.name,
      id: genRawFieldsInterpolationValue(fieldsOrigin, field),
      type: `raw_${field.type}`,
      group: group || 'Campos adicionais'
    }))
  ]
}
